import React, { useRef, useState } from 'react';
import Icon from '../../../Icons/general/Icon';

export default function Dropzone({ onFileSelected }) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const inputRef = useRef();

  const handleFile = (file) => {
    if (!file || !file.type.startsWith('video/')) return;

    const videoUrl = URL.createObjectURL(file);
    setPreviewUrl(videoUrl);
    onFileSelected?.(file); // Callback opcional
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (
    <div
      className="flex flex-col items-center justify-center w-full border-2 border-dashed border-stone-200 rounded-xl p-6 text-center text-gray-600 cursor-pointer hover:bg-green-50 transition"
      onClick={() => inputRef.current.click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
    >
      <input
        ref={inputRef}
        type="file"
        accept="video/mp4,video/x-m4v,video/*"
        className="hidden"
        onChange={handleChange}
      />
      <Icon svg="upload" className="w-[4rem] h-[4rem] fill-gray-500" />
      <p className="text-sm">Haz clic o arrastra un video aquí</p>

      {previewUrl && (
        <video
          src={previewUrl}
          controls
          className="mt-4 max-h-60 w-full object-contain rounded shadow"
        />
      )}
    </div>
  );
}
